import React, { useState, useRef, useEffect, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import QrScanner from 'qr-scanner';
import AuthContext from '../contexts/AuthContext';
import '../styles/LoginPage.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const videoRef = useRef(null);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`/api/login`, {
        username,
        password,
      });
      if (response.data.success) {
        login(response.data.token);
        navigate('/questionnaire');
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setError('Falscher Benutzername oder falsches Passwort');
      } else if (error.response && error.response.status === 403) {
        setError('Sie haben bereits an allen Umfragen teilgenommen');
      } else {
        setError('Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      }
    }
  };

  const handleScan = useCallback(async (result) => {
    if (result) {
      try {
        const parsedData = JSON.parse(result);
        const response = await axios.post(`/api/login`, {
          username: parsedData.username,
          password: parsedData.password,
        });
        if (response.data.success) {
          login(response.data.token);
          navigate('/questionnaire');
        } else {
          setError('Ungültiger QR-Code');
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError('Falscher Benutzername oder falsches Passwort');
        } else if (error.response && error.response.status === 403) {
          setError('Sie haben bereits an allen Umfragen teilgenommen');
        } else {
          setError('Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
        }
      }
    }
  }, [navigate, login]);

  useEffect(() => {
    if (isQrModalOpen) {
      const qrScanner = new QrScanner(videoRef.current, result => handleScan(result));
      qrScanner.start();
      return () => qrScanner.stop();
    }
  }, [isQrModalOpen, handleScan]);

  return (
    <div className="login-container">
      <h1>Anmelden</h1>
      {error && <p className="error-message">{error}</p>}
      
      <div className="login-field">
        <label htmlFor="username">Benutzername:</label>
        <input
          type="text"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>

      <div className="login-field">
        <label htmlFor="password">Passwort:</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <button className="login-button" onClick={handleLogin}>
        Anmelden
      </button>

      <button className="qr-button" onClick={() => setIsQrModalOpen(true)}>
        QR-Code scannen
      </button>

      {isQrModalOpen && (
        <div className="qr-modal">
          <div className="qr-modal-content">
            {error && <p className="error-message">{error}</p>}
            <button className="qr-close-button" onClick={() => setIsQrModalOpen(false)}>Close</button>
            <video ref={videoRef} style={{ width: '100%' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;